import { combineReducers } from "redux";
import { all } from "redux-saga/effects";

import * as auth from "../app/modules/Auth/_redux/authRedux";

import { AuditLogsSlice } from "../app/modules/coinWrap/_redux/AuditLogs/AuditLogsSlice";
import { BillingSlice } from "../app/modules/coinWrap/_redux/Billing/BillingSlice";
import { ControlIdActionSlice } from "../app/modules/coinWrap/_redux/ControlIdActions/ControlIdActionsSlice";
import { AuditSlice } from "../app/modules/coinWrap/_redux/Conversion/Audit/AuditSlice";
import { ProductionSlice } from "../app/modules/coinWrap/_redux/Conversion/Production/ProductionSlice";
import { WrapSlice } from "../app/modules/coinWrap/_redux/Conversion/Wrap/WrapSlice";
import { DashboardSlice } from "../app/modules/coinWrap/_redux/Dashboard/DashboardSlice";
import { DocumentsSlice } from "../app/modules/coinWrap/_redux/Documents/DocumentsSlice";
import { generalSlice } from "../app/modules/coinWrap/_redux/general/generalSlice";
import { LedgerSlice } from "../app/modules/coinWrap/_redux/Ledger/LedgerSlice";
import { AccountsSlice } from "../app/modules/coinWrap/_redux/Models/Account/AccountsSlice";
import { BillingCategoriesSlice } from "../app/modules/coinWrap/_redux/Models/BillingCategories/BillingCategoriesSlice";
import { CarrierSlice } from "../app/modules/coinWrap/_redux/Models/Carrier/CarrierSlice";
import { CoinTypeProductsSlice } from "../app/modules/coinWrap/_redux/Models/CoinTypeProducts/CoinTypeProductsSlice";
import { CoinTypesSlice } from "../app/modules/coinWrap/_redux/Models/CoinTypes/CoinTypesSlice";
import { CommonDropdownSlice } from "../app/modules/coinWrap/_redux/Models/CommonDropdown/CommonDropdownSlice";
import { CustomerCarriersSlice } from "../app/modules/coinWrap/_redux/Models/CustomerCarriers/CustomerCarriersSlice";
import { CustomersSlice } from "../app/modules/coinWrap/_redux/Models/Customers/CustomersSlice";
import { DepositorsSlice } from "../app/modules/coinWrap/_redux/Models/Depositors/DepositorsSlice";
import { DivisionsSlice } from "../app/modules/coinWrap/_redux/Models/Divisions/DivisionsSlice";
import { EmployeeLocationSlice } from "../app/modules/coinWrap/_redux/Models/EmployeeLocation/EmployeeLocationSlice";
import { EmployeesSlice } from "../app/modules/coinWrap/_redux/Models/Employees/EmployeesSlice";
import { InventorySlice } from "../app/modules/coinWrap/_redux/Models/Inventory/InventorySlice";
import { LocationsSlice } from "../app/modules/coinWrap/_redux/Models/Locations/LocationsSlice";
import { OrganizationsSlice } from "../app/modules/coinWrap/_redux/Models/Organization/OrganizationsSlice";
import { ProductionLineSlice } from "../app/modules/coinWrap/_redux/Models/ProductionLine/ProductionLineSlice";
import { ProductsSlice } from "../app/modules/coinWrap/_redux/Models/Products/ProductsSlice";
import { RegionsSlice } from "../app/modules/coinWrap/_redux/Models/Regions/RegionsSlice";
import { UnitTypesSlice } from "../app/modules/coinWrap/_redux/Models/UnitTypes/UnitTypeSlice";
import { UsersSlice } from "../app/modules/coinWrap/_redux/Models/Users/UsersSlice";
import { StatusSlice } from "../app/modules/coinWrap/_redux/Orders/Status/StatusSlice";
import { PermissionsSlice } from "../app/modules/coinWrap/_redux/RolesAndPermissionsModels/Permissions/PermissionsSlice";
import { RolesSlice } from "../app/modules/coinWrap/_redux/RolesAndPermissionsModels/Roles/RolesSlice";
import { RolesAndPermissionSlice } from "../app/modules/coinWrap/_redux/RolesAndPermissionsModels/RolesAndPermission/RolesAndPermissionSlice";
import { ShipmentFilesSlice } from "../app/modules/coinWrap/_redux/ShipmentFiles/ShipmentFilesSlice";
import { sortingSlice } from "../app/modules/coinWrap/_redux/Sorting/SortingSlice";
import { TenderIDAuditLogsSlice } from "../app/modules/coinWrap/_redux/TransportOrders/TenderIDAuditLogsSlice";
import { TransportOrdersSlice } from "../app/modules/coinWrap/_redux/TransportOrders/TransportOrdersSlice";
import { VerificationSlice } from "../app/modules/coinWrap/_redux/Verification/VerificationSlice";
import { VaultSlice } from "../app/modules/coinWrap/_redux/Vault/VaultSlice";
import { SidebarFilterSlice } from "../app/modules/coinWrap/_redux/Common/SidebarFilterSlice";
import { IncidentReportModelSlice } from "../app/modules/coinWrap/_redux/Satellite/IncidentReportModel/IncidentReportModelSlice";
import { WaitingOnReportSlice } from "../app/modules/coinWrap/_redux/Satellite/WaitingOnReport/WaitingOnReportSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  general: generalSlice.reducer,
  coinTypes: CoinTypesSlice.reducer,
  coinTypeProducts: CoinTypeProductsSlice.reducer,
  carriers: CarrierSlice.reducer,
  transportOrders: TransportOrdersSlice.reducer,
  tenderIDAuditLogs: TenderIDAuditLogsSlice.reducer,
  auditLogs: AuditLogsSlice.reducer,
  users: UsersSlice.reducer,
  ShipmentFiles: ShipmentFilesSlice.reducer,
  employees: EmployeesSlice.reducer,
  employeeLocation: EmployeeLocationSlice.reducer,
  regions: RegionsSlice.reducer,
  divisions: DivisionsSlice.reducer,
  documents: DocumentsSlice.reducer,
  unitTypes: UnitTypesSlice.reducer,
  organizations: OrganizationsSlice.reducer,
  accounts: AccountsSlice.reducer,
  permissions: PermissionsSlice.reducer,
  roles: RolesSlice.reducer,
  rolesAndPermissions: RolesAndPermissionSlice.reducer,
  inventory: InventorySlice.reducer,
  products: ProductsSlice.reducer,
  locations: LocationsSlice.reducer,
  status: StatusSlice.reducer,
  ledger: LedgerSlice.reducer,
  customerCarriers: CustomerCarriersSlice.reducer,
  depositors: DepositorsSlice.reducer,
  customers: CustomersSlice.reducer,
  controlIdAction: ControlIdActionSlice.reducer,
  dashboard: DashboardSlice.reducer,
  productionLine: ProductionLineSlice.reducer,
  wrapping: WrapSlice.reducer,
  production: ProductionSlice.reducer,
  billingCategories: BillingCategoriesSlice.reducer,
  billing: BillingSlice.reducer,
  verification: VerificationSlice.reducer,
  sorting: sortingSlice.reducer,
  audit: AuditSlice.reducer,
  commonDropdown: CommonDropdownSlice.reducer,
  vault: VaultSlice.reducer,
  sidebarFilter: SidebarFilterSlice.reducer,
  incidentReportModel: IncidentReportModelSlice.reducer,
  waitingOnReport: WaitingOnReportSlice.reducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
